import { useMutation } from '@tanstack/react-query'
import { putEstimate } from 'services/PaymentsService'

export const usePutEstimateMutation = () => {
  return useMutation({ mutationFn: putEstimate })
}
